import { Roboto_Mono } from 'next/font/google';
import { HTMLAttributes } from 'react';

const robotoMono = Roboto_Mono({
    subsets: ['latin']
});

const KiLabel = ({ children, className = '', ...props }: HTMLAttributes<HTMLSpanElement>) => {
    return (
        <span className={`${robotoMono.className} tw-uppercase ${className}`} {...props}>
            {children}
        </span>
    );
};

export default KiLabel;
